// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.animated.fastest {
  animation-duration: .3s;
}

.text-disabled {
  color: #b5bbc8;
}

blockquote.warning {
  border-left-color: #f39c12;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/containers/App/styles/default.css","webpack://./services/frontend/app/containers/App/styles/default.css"],"names":[],"mappings":"AADA;ECEE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".animated.fastest {\n  animation-duration: 300ms;\n}\n\n.text-disabled {\n  color: #b5bbc8;\n}\n\nblockquote.warning {\n  border-left-color: #f39c12;\n}\n",".animated.fastest {\n  animation-duration: .3s;\n}\n\n.text-disabled {\n  color: #b5bbc8;\n}\n\nblockquote.warning {\n  border-left-color: #f39c12;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
